<template>
    <div>
        <el-row class="u-mt-10 u-mb-20" :gutter="10">
            <el-col :xs="24" :sm="4" :md="4">
                <el-input v-model="filtro.id" placeholder="Nº protocolo" @keyup.native.enter="loadingProtocolos"></el-input>
            </el-col>
            <el-col :xs="24" :sm="10" :md="10">
                <el-input v-model="filtro.titulo" placeholder="Pesquisar assunto..." @keyup.native.enter="loadingProtocolos"></el-input>
            </el-col>
            <el-col :xs="24" :sm="10" :md="10" class="u-text-right">
                <router-link to="/admin/protocolo/cadastro" class="btn-new-register">
                    <el-button type="primary">NOVO PROTOCOLO</el-button>
                </router-link>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 90px;">Nº</th>
                        <th>Assunto</th>
                        <th class="hidden-mobile">Instituição</th>
                        <th class="hidden-mobile">Data</th>
                        <th style="width: 200px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ (item.titulo || '-') | truncate(60, '...') }}</td>
                        <td class="hidden-mobile">
                            {{ item.instituicao ? item.instituicao.nome : 'SECRETARIA' }}
                        </td>
                        <td class="hidden-mobile">{{ formatDateBR(item.created_at) }}</td>
                        <td class="u-text-center acao">
                            <router-link :to="'/admin/protocolo/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                            <el-button @click="printProtocolo(item.id)" title="Imprimir" type="primary" icon="el-icon-printer" size="mini" plain class="u-mr-10"></el-button>
                            <el-button @click="deleteProtocolo(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination
                            :current-page="paginate.page"
                            class="u-mt-10"
                            :total="paginate.qtdItens"
                            @current-change="getPagePagination"
                            :page-size="30"
                            background
                            layout="prev, pager, next"
                            small
                        ></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: {
            id: '',
            titulo: '',
            instituicao_id: null
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: []
    }),
    computed: {
        isSMED () {
            const t = Number(this.$store.state.user.tipo)
            return [4, 5, 6].includes(t)
        }
    },
    mounted () {
        this.loadingProtocolos()
    },
    methods: {
        formatDateBR (d) {
            if (!d) return '-'
            let s = String(d)

            // Normaliza formatos comuns vindos do backend:
            // - YYYY-MM-DD
            // - YYYY-MM-DD HH:mm:ss
            // - YYYY-MM-DDTHH:mm:ss(.sss)Z
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                s = s + 'T00:00:00'
            } else if (s.includes(' ') && !s.includes('T')) {
                s = s.replace(' ', 'T')
            }

            const dt = new Date(s)
            if (isNaN(dt.getTime())) return '-'
            return dt.toLocaleDateString('pt-BR')
        },
        loadingProtocolos () {
            this.statusList = false
            this.items = []

            const filtro = { ...this.filtro }
            // SMED sempre opera como Secretaria (sem instituição)
            delete filtro.instituicao_id

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/protocolo/getAllPaginate?page=` + this.paginate.page, filtro, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.items = response.data.data
                    this.paginate.qtdItens = response.data.total
                    this.paginate.from = response.data.from
                    this.paginate.to = response.data.to
                    this.statusList = true
                }).catch((error) => { this.$store.commit('throwException', error) })
        },
        deleteProtocolo (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este protocolo?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => {
                    window.eventBus.$emit('loading', true)
                    this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/protocolo/delete/` + id, this.$store.getters.getHeaderAuth)
                        .then(() => {
                            window.eventBus.$emit('loading', false)
                            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                            this.loadingProtocolos()
                        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
                }).catch(() => {})
        },
        printProtocolo (id) {
            window.eventBus.$emit('print', { url: '/api/pdf/renderProtocolo', param: { id } })
        },
        getPagePagination (page) {
            this.paginate.page = page
            this.loadingProtocolos()
        }
    }
}
</script>

